import TranslationUtils from '@gik/core/utils/TranslationUtils';

const blockName = 'reset-password';

// TODO: fill in missing translations
const translations = {
  title: 'Reset password.',
  description: 'Reset your password.',

  formSubmitButton: 'Reset',
};

export default {
  [blockName]: translations,
};

export const translationKeys: typeof translations = TranslationUtils.mapKeys(blockName, translations);
